import React from 'react';
import { observer } from 'mobx-react';
import { HubModuleVM } from './hub-module.viewmodel';
import { EventsModuleVM } from './_events-module/events-module.viewmodel';
import { EventsModuleModal } from './_events-module/events-module-modal';
import { SpeakersModuleVM } from './_speakers-module/speakers-module.viewmodel';
import { SpeakersModuleModal } from './_speakers-module/speakers-module-modal';
import { RichTextModuleVM } from './_rich-text-module/rich-text-module.viewmodel';
import { RichTextModuleModal } from './_rich-text-module/rich-text-module-modal';
import { CustomHtmlModuleVM } from './_custom-html-module/custom-html-module.viewmodel';
import { CustomHtmlModuleModal } from './_custom-html-module/custom-html-module-modal';
import { MyEventsModuleVM } from './_my-events-module/my-events-module.viewmodel';
import { MyEventsModuleModal } from './_my-events-module/my-events-module-modal';

type ModuleModalHostProps = {
    vm: HubModuleVM;
    isNew: boolean;
    onCancel: () => void;
    onConfirm: () => void;
};

export const ModuleModalHost: React.FC<ModuleModalHostProps> = observer(({ vm, isNew, onCancel, onConfirm }) => {
    if (vm instanceof EventsModuleVM) {
        return <EventsModuleModal vm={vm} isNew={isNew} onCancel={onCancel} onConfirm={onConfirm} />;
    }
    if (vm instanceof SpeakersModuleVM) {
        return <SpeakersModuleModal vm={vm} isNew={isNew} onCancel={onCancel} onConfirm={onConfirm} />;
    }
    if (vm instanceof RichTextModuleVM) {
        return <RichTextModuleModal vm={vm} isNew={isNew} onCancel={onCancel} onConfirm={onConfirm} />;
    }
    if (vm instanceof CustomHtmlModuleVM) {
        return <CustomHtmlModuleModal vm={vm} isNew={isNew} onCancel={onCancel} onConfirm={onConfirm} />;
    }
    if (vm instanceof MyEventsModuleVM) {
        return <MyEventsModuleModal vm={vm} isNew={isNew} onCancel={onCancel} onConfirm={onConfirm} />;
    }
    return null;
});
